import { apiCall } from "./service";
import {
  BASE_URL,
  URL_PROGRAM,
  URL_PROJECTS,
  URL_SCOPE,
  URL_GET_SCOPE,
  URL_CREATE_SCOPE,
  URL_UPDATE_SCOPE,
  URL_DELETE_SCOPE,
  URL_SCOPE_FLAG,
  URL_TASK,
  URL_CREATE_TASK,
  URL_TASK_FLAG,
  URL_GET_TASK_DETAILS,
  URL_UPDATE_TASK,
  URL_DELETE_TASK,
  URL_PORTFOLIO,
  URL_RESOURCE_SHIFT,
  URL_RESOURCES_MONITOR,
  URL_MILESTONES,
  URL_TASKS,
} from "./URL";

export const api = {
  scopeRequest(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url;
    
    switch (parent) {
     
      case "Portfolio":
        url = `${BASE_URL}Portfolios/${id}/Scopes`;
        break;
        
      case "Program":
        url = `${BASE_URL}Programs/${id}/Scopes`;
        break;

      case "Project":
        url = `${BASE_URL}Projects/${id}/Scopes`;
        break;
        
      default:
        url = ``; //set to empty to prevent fetch all records but still throw error
    }
  
    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;
  
    return apiCall.pagination({ url: fullUrl });
  },

  milestonesRequest(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url;
    
    switch (parent) {
     
      case "Portfolio":
        url = `${BASE_URL}Portfolios/${id}/Milestones`;
        break;
        
      case "Program":
        url = `${BASE_URL}Programs/${id}/Milestones`;
        break;

      case "Project":
        url = `${BASE_URL}Projects/${id}/Milestones`;
        break;
        
      default:
        url = ``; //set to empty to prevent fetch all recors but still throw error
    }
  
    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;
  
    return apiCall.pagination({ url: fullUrl });
  },

  sortScopeItemsRequest(params) {
    if (params.parent === "Project")
      return apiCall.pagination({
        url: `${URL_PROJECTS}/${params.id}/Scopes?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    if (params.parent === "Program")
      return apiCall.pagination({
        url: `${URL_PROGRAM}${params.id}/Scopes?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    if (params.parent === "Scope")
      return apiCall.pagination({
        url: `${URL_SCOPE}?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    if (params.parent === "Portfolio")
      return apiCall.pagination({
        url: `${URL_PORTFOLIO}/${params.id}/Scopes?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    // return apiCall.pagination({url: `${URL_SCOPE}${params.id}/Scopes?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`, isAuthToken: true, params});
  },

  getScopeDetailsRequest(params) {
    return apiCall.get({
      url: `${URL_GET_SCOPE}${params.id}`,
      isAuthToken: true,
      params,
    });
  },

  createScopeRequest(params) {
    return apiCall.post({ url: `${URL_CREATE_SCOPE}`, params });
  },

  updateScopeRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_SCOPE}${params.id}`,
      params: params.payload,
    });
  },

  deleteScopeRequest(params) {
    return apiCall.delete({ url: `${URL_DELETE_SCOPE}${params}` });
  },

  duplicateScopeRequest(params) {
    return apiCall.post({
      url: `${URL_SCOPE}/${params.id}/duplicate`,
      params: params.payload || {},
    });
  },

  duplicateTaskRequest(params) {
    return apiCall.post({
      url: `${URL_TASKS}/${params.id}/duplicate`,
      params: params.payload || {},
    });
  },

  updateScopeFlagRequest(params) {
    return apiCall.patch({
      url: `${URL_SCOPE_FLAG}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  taskRequest(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url;

    switch (parent) {

      case "Scope":
        url = `${BASE_URL}Scopes/${id}/Tasks`;
        break;

      default:{
        return;
      }
    }
  
    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;
  
    return apiCall.pagination({ url: fullUrl });
  },

  createTaskRequest(params) {
    return apiCall.post({
      url: `${URL_CREATE_TASK}`,
      isAuthToken: true,
      params,
    });
  },

  getTaskDetails(params) {
    return apiCall.get({
      url: `${URL_GET_TASK_DETAILS}${params.id}`,
      isAuthToken: true,
      params,
    });
  },

  getTaskAttachements(params) {
    return apiCall.get({
      url: `${URL_GET_TASK_DETAILS}${params.id}/attachments`,
      isAuthToken: true,
      params,
    });
  },

  getTaskAssignments(params) {
    return apiCall.get({
      url: `${URL_GET_TASK_DETAILS}${params.id}/assignments`,
      isAuthToken: true,
      params,
    });
  },

  updateTaskRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_TASK}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  validateNewAllocations(params) {
    return apiCall.post({
      url: `${URL_TASKS}/validate-new-allocations`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  validateAllocation(params) {
    return apiCall.post({
      url: `${URL_UPDATE_TASK}${params.taskId}/Allocations/validate-allocation`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  validateTaskDates(params) {
    return apiCall.post({
      url: `${URL_UPDATE_TASK}${params.taskId}/validate-dates-change`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  deleteTaskRequest(params) {
    return apiCall.delete({
      url: `${URL_DELETE_TASK}${params.id}`,
      isAuthToken: true,
      params,
    });
  },

  sortTasksRequest(params) {
    return apiCall.pagination({
      url: `${URL_TASK}${params.id}/Tasks?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
      isAuthToken: true,
      params,
    });
  },

  searchAllScopeRequest(params) {
    return apiCall.get({
      url: `${BASE_URL}Scopes?searchTerm=${params.value}&pageNumber=${params.page}&pageSize=${params.size}`,
      isAuthToken: true,
      params,
    });
  },

  searchScopeRequest(params) {
    return apiCall.get({
      url: `${BASE_URL}Projects/${params.projectId}/Scopes?searchTerm=${params.value}&pageNumber=${params.page}&pageSize=${params.size}`,
      isAuthToken: true,
      params,
    });
  },

  resourceShiftsRequest(params) {
    return apiCall.post({
      url: `${URL_RESOURCE_SHIFT}`,
      isAuthToken: true,
      params,
    });
  },

  updateTaskFlagRequest(params) {
    return apiCall.patch({
      url: `${URL_TASK_FLAG}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  updateTaskStatusRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_TASK}${params.id}/Status`,
      isAuthToken: true,
      params: params.payload,
    });
  },
  resourcesMonitorRequest(param) {
    const { StartDate, EndDate, Resources } = param;
    if (StartDate && EndDate) {
      return apiCall.get({
        url: `${URL_RESOURCES_MONITOR}?Resources=${Resources}&StartDate=${StartDate}&EndDate=${EndDate}`,
        isAuthToken: true,
      });
    } else {
      return apiCall.get({
        url: `${URL_RESOURCES_MONITOR}?Resources=${param.Resources}`,
        isAuthToken: true,
      });
    }
  },
  getTeam(id) { 
    return apiCall.get({url: `${URL_SCOPE}/${id}/Resources`});
  },
  AddResourceToScope(scopeId, resourceId) {
    return apiCall.post({url: `${URL_SCOPE}/${scopeId}/Resources/${resourceId}`});
  },
  RemoveResourceFromScope(scopeId, resourceId) {
    return apiCall.delete({url: `${URL_SCOPE}/${scopeId}/Resources/${resourceId}`});
  },
  patchTaskField(taskId, field, value) {
    return apiCall.patch({
      url: `${URL_UPDATE_TASK}${taskId}`,
      isAuthToken: true,
      params: [{ op: "replace", path: `/${field}`, value }],
    });
  },
  patchScopeField(scopeId, field, value) {
    return apiCall.patch({
      url: `${URL_UPDATE_SCOPE}${scopeId}`,
      isAuthToken: true,
      params: [{ op: "replace", path: `/${field}`, value }],
    });
  },
  updateTaskMilestoneStatus(taskId, isMilestone) {
    return apiCall.put({
      url: `${URL_UPDATE_TASK}${taskId}/milestone-status`,
      isAuthToken: true,
      params: { isMilestone },
    });
  },
  updateScopeMilestoneStatus(scopeId, isMilestone) {
    return apiCall.put({
      url: `${URL_UPDATE_SCOPE}${scopeId}/milestone-status`,
      isAuthToken: true,
      params: { isMilestone },
    });
  },
};
export default api;
